import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";
import { useEffect } from "react";

// Environment variables with type safety
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || "";
const SENTRY_TUNNEL = import.meta.env.VITE_SENTRY_TUNNEL || "/api/tunnel";
const TRACES_SAMPLE_RATE = Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || "1.0");
const REPLAYS_SESSION_SAMPLE_RATE = Number(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE || "0.5");
const REPLAYS_ON_ERROR_SAMPLE_RATE = Number(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || "1.0");

interface SentryConfig {
  enabled: boolean;
}

export const initializeSentry = ({ enabled }: SentryConfig) => {
  if (!SENTRY_DSN) {
    console.warn("Sentry DSN not provided. Error tracking will be disabled.");
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    tunnel: SENTRY_TUNNEL,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: TRACES_SAMPLE_RATE,

    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/((\w|-)+\.)*dataroot\.cl/,
      /^https:\/\/(\w|-)+\.vercel\.app/,
    ],

    // Session Replay
    replaysSessionSampleRate: REPLAYS_SESSION_SAMPLE_RATE,
    replaysOnErrorSampleRate: REPLAYS_ON_ERROR_SAMPLE_RATE,

    enabled: enabled,
  });
};